<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <span class="font-weight-regular">ดาว์นโหลด Transaction</span>
      </v-card-title>
      <v-divider></v-divider>
      <v-progress-linear
        :active="loading"
        :indeterminate="loading"
      ></v-progress-linear>
      <v-card-text class="pa-5">
        <v-form ref="form" lazy-validation @submit.prevent="onSubmit">
          <v-row>
            <v-col md="3" xl="2">
              <DatePicker
                :label="dateStartLabel"
                :value="dateStartValue"
                :max="dateEndValue"
                :hideDetails="true"
                @input="dateStartInput"
              />
            </v-col>
            <v-col md="3" xl="2">
              <DatePicker
                :label="dateEndLabel"
                :value="dateEndValue"
                :min="dateStartValue"
                :hideDetails="true"
                @input="dateEndInput"
              />
            </v-col>
          </v-row>
          <div class="mt-2">
            <v-card outlined class="pa-4">
              <h4>แหล่งข้อมูล</h4>
              <div
                v-for="transactionSource in transactionSources"
                :key="transactionSource.transaction_source_uuid"
              >
                <v-checkbox
                  v-model="transaction_source"
                  class="mt-2 d-inline-block"
                  hide-details
                  :label="transactionSource.title_short"
                  :value="transactionSource.transaction_source_uuid"
                ></v-checkbox>
              </div>
            </v-card>
          </div>
          <div class="mt-2">
            <v-card outlined class="pa-4">
              <h4 class="mb-2">ข้อมูลรหัสประจำตัว</h4>
              <v-col class="d-flex" cols="12" sm="6">
                <v-select
                  v-model="primary_id"
                  :items="
                    identificationCodeList.filter(
                      (item) => item.value !== secondary_id
                    )
                  "
                  :rules="[(v) => !!v || 'จำเป็นต้องเลือกรหัสประจำตัว']"
                  label="เลือกรหัสประจำตัว"
                  dense
                  clearable
                ></v-select>
              </v-col>
              <v-col class="d-flex" cols="12" sm="6">
                <v-select
                  v-model="secondary_id"
                  :items="
                    identificationCodeList.filter(
                      (item) => item.value !== primary_id
                    )
                  "
                  label="เลือกรหัสประจำตัวใช้แทน (หากไม่มีข้อมูลด้านบน)"
                  dense
                  clearable
                ></v-select>
              </v-col>
            </v-card>
          </div>
          <div class="mt-2">
            <v-card outlined class="pa-4">
              <h4>ตำแหน่งเริ่มต้นรหัสประจำตัวที่ใช้</h4>
              <div style="width: 280px">
                <v-text-field
                  type="number"
                  outlined
                  dense
                  v-model="start_digit"
                  :rules="[
                    (v) =>
                      (v && v >= 1 && v <= 31) ||
                      'ตำแหน่งเริ่มต้นต้องเป็นตัวเลขอยู่ระหว่าง 1 ถึง 31',
                    (v) =>
                      (v && v < Number(end_digit)) ||
                      'ตำแหน่งเริ่มต้นต้องน้อยกว่าตำแหน่งสุดท้าย',
                  ]"
                ></v-text-field>
              </div>
              <h4>ตำแหน่งสุดท้ายรหัสประจำตัวที่ใช้</h4>
              <div style="width: 280px">
                <v-text-field
                  type="number"
                  outlined
                  dense
                  v-model="end_digit"
                  :rules="[
                    (v) =>
                      (v && v >= 2 && v <= 32) ||
                      'ตำแหน่งสุดท้ายต้องเป็นตัวเลขอยู่ระหว่าง 2 ถึง 32',
                    (v) =>
                      (v && v > Number(start_digit)) ||
                      'ตำแหน่งสุดท้ายต้องมากกว่าตำแหน่งเริ่มต้น',
                  ]"
                ></v-text-field>
              </div>
            </v-card>
          </div>
          <div class="mt-2">
            <v-card outlined class="pa-4">
              <div>
                <v-checkbox
                  v-model="filterTracking"
                  class="mt-0 d-inline-block"
                  label="กรองข้อมูล Tracking"
                ></v-checkbox>
              </div>
              <v-switch
                class="mt-0 ml-8 d-inline-block"
                v-model="isTracking"
                :disabled="!filterTracking"
                :label="`${
                  isTracking ? 'เฉพาะข้อมูล Tracking' : 'ไม่เอาข้อมูล Tracking'
                }`"
                hide-details
              ></v-switch>
            </v-card>
          </div>
          <div class="mt-2">
            <v-card outlined class="pa-4">
              <div>
                <v-checkbox
                  v-model="filterTimeAttendance"
                  class="mt-0 d-inline-block"
                  label="กรองข้อมูล Time Attendance"
                ></v-checkbox>
              </div>
              <v-switch
                class="mt-0 ml-8 d-inline-block"
                v-model="isTimeAttendanceSuccess"
                :disabled="!filterTimeAttendance"
                :label="`${
                  isTimeAttendanceSuccess
                    ? 'เฉพาะข้อมูลการลงเวลาทำงานสำเร็จ'
                    : 'เฉพาะข้อมูลการลงเวลาทำงานไม่สำเร็จ'
                }`"
                hide-details
              ></v-switch>
            </v-card>
          </div>
          <div class="mt-10">
            <v-btn
              class="mr-4"
              color="primary"
              @click="onDownload"
              :disabled="loading"
              >ดาวน์โหลดไฟล์
            </v-btn>
          </div>
        </v-form>
      </v-card-text>
    </v-card>

    <v-dialog v-model="dialogProgress" persistent width="320">
      <div class="pa-4 white">
        <v-progress-linear :value="progressValue" height="25">
          <strong>{{ Math.ceil(progressValue) }}%</strong>
        </v-progress-linear>
      </div>
    </v-dialog>
  </v-container>
</template>

<script>
import moment from 'moment'
import { mapActions } from 'vuex'

// @ is an alias to /src
import DatePicker from '@/components/DatePicker.vue'

export default {
  components: {
    DatePicker,
  },

  data() {
    return {
      identificationCodeList: [
        { text: 'รหัสพนักงาน', value: 'employee_code' },
        { text: 'รหัสอ้างอิง', value: 'employee_reference_code' },
        { text: 'Serial Card', value: 'card_serial_number' },
      ],
      primary_id: 'employee_code',
      secondary_id: '',
      start_digit: '1',
      end_digit: '15',
      filterTracking: false,
      isTracking: false,
      filterTimeAttendance: false,
      isTimeAttendanceSuccess: false,
      dialogProgress: false,
      progressValue: 0,
      transaction_source: [],
      loading: false,
      dateStartLabel: 'วันที่เริ่มต้น',
      dateStartValue: moment().format('YYYY-MM-DD'),
      dateEndLabel: 'วันที่สิ้นสุด',
      dateEndValue: moment().format('YYYY-MM-DD'),
      interval: null,
      timeout: null,
    }
  },
  computed: {
    user() {
      return this.$store.state.authentication.user
    },
    transactionSources() {
      return this.$store.state.download.transactionSources
    },
  },
  created() {
    this.$store.commit('SET_BREADCRUMBS', [
      { text: 'หน้าหลัก', disabled: false, to: '/' },
      {
        text: 'ดาว์นโหลด Transaction',
        disabled: true,
      },
    ])

    this.loadData()
  },
  methods: {
    ...mapActions({
      fetchTransactionSources: 'download/fetchTransactionSources',
      downloadTransaction: 'download/downloadTransaction',
      generateFileProgress: 'download/generateFileProgress',
    }),
    dateStartInput(value) {
      this.dateStartValue = value
    },
    dateEndInput(value) {
      this.dateEndValue = value
    },
    onDownload() {
      if (this.$refs.form.validate()) {
        const transaction = {
          start_date: this.dateStartValue,
          end_date: this.dateEndValue,
          transaction_source: this.transaction_source,
          primary_id: {
            employee_code: this.primary_id === 'employee_code',
            employee_reference_code:
              this.primary_id === 'employee_reference_code',
            card_serial_number: this.primary_id === 'card_serial_number',
          },
          secondary_id: {
            employee_code: this.secondary_id === 'employee_code',
            employee_reference_code:
              this.secondary_id === 'employee_reference_code',
            card_serial_number: this.secondary_id === 'card_serial_number',
          },
          is_tracking_only: this.filterTracking
            ? this.isTracking
              ? true
              : false
            : null,
          is_time_attendance_status_success: this.filterTimeAttendance
            ? this.isTimeAttendanceSuccess
              ? true
              : false
            : null,
          start_digit: Number(this.start_digit),
          end_digit: Number(this.end_digit),
        }

        const { company_uuid } = this.$store.state.authentication.company
        const payload = {
          company_uuid,
          body: transaction,
        }

        this.$store.state.loading = true
        this.downloadTransaction(payload)
          .then((res) => {
            this.$store.state.loading = false

            if (this.user) {
              const userConfig = localStorage.getItem(this.user.uuid)
              const menuEmployee = userConfig
                ? JSON.parse(userConfig)['menu-employee']
                : null

              const config = {
                ['menu-employee']: menuEmployee ? menuEmployee : undefined,
                ['menu-download-transaction']: transaction,
              }

              window.localStorage.setItem(
                this.user.uuid,
                JSON.stringify(config)
              )
            }

            if (res.total === 0) {
              const snackbar = {
                show: true,
                color: 'warning',
                timeout: 4000,
                message: 'ไม่มีข้อมูล',
              }

              this.$store.commit('SET_SNACKBAR', snackbar)
              return
            }

            this.progressValue = 0
            this.dialogProgress = true

            this.downloadProgress(res.job_process_uuid, res.ping_after_ms)
          })
          .catch((error) => {
            this.$store.state.loading = false
            this.dialogProgress = false

            const snackbar = {
              show: true,
              color: 'error',
              timeout: -1,
              message:
                error?.response?.data?.message || 'Something went wrong!',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)
          })
      }
    },
    downloadProgress(job_process_uuid, ping_after_ms) {
      this.interval = setInterval(() => {
        this.generateFileProgress(job_process_uuid)
          .then((res) => {
            if (res.total === 0) {
              this.progressValue = 100
              this.timeout = setTimeout(() => {
                this.dialogProgress = false
              }, 200)

              clearInterval(this.interval)

              const snackbar = {
                show: true,
                color: 'warning',
                timeout: 4000,
                message: 'ไม่มีข้อมูล',
              }

              this.$store.commit('SET_SNACKBAR', snackbar)
              return
            }

            if (res.is_success) {
              this.progressValue = 100
              this.timeout = setTimeout(() => {
                this.dialogProgress = false
              }, 200)

              const fileUrl = res.resource_uri
              const fileName = fileUrl.split('/').pop()

              const a = document.createElement('a')
              a.setAttribute('hidden', '')
              a.setAttribute('href', fileUrl)
              a.setAttribute('download', fileName)
              document.body.appendChild(a)
              a.click()
              document.body.removeChild(a)

              clearInterval(this.interval)
            } else {
              this.progressValue = (100 / res.total) * res.progress
            }
          })
          .catch((error) => {
            this.dialogProgress = false

            const snackbar = {
              show: true,
              color: 'error',
              timeout: -1,
              message:
                error?.response?.data?.message || 'Something went wrong!',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)

            clearInterval(this.interval)
          })
      }, ping_after_ms)
    },
    loadData() {
      this.fetchTransactionSources()
        .then(() => {
          this.loading = false

          if (this.user) {
            const userConfig = localStorage.getItem(this.user.uuid)
            const menuDownloadTransaction = userConfig
              ? JSON.parse(userConfig)['menu-download-transaction']
              : null
            if (menuDownloadTransaction) {
              this.transaction_source = [
                ...menuDownloadTransaction.transaction_source,
              ]
              this.primary_id = menuDownloadTransaction.primary_id.employee_code
                ? 'employee_code'
                : menuDownloadTransaction.primary_id.employee_reference_code
                ? 'employee_reference_code'
                : 'card_serial_number'
              this.secondary_id = menuDownloadTransaction.secondary_id
                .employee_code
                ? 'employee_code'
                : menuDownloadTransaction.secondary_id.employee_reference_code
                ? 'employee_reference_code'
                : menuDownloadTransaction.secondary_id.card_serial_number
                ? 'card_serial_number'
                : ''
              this.start_digit = menuDownloadTransaction.start_digit
              this.end_digit = menuDownloadTransaction.end_digit
              this.filterTracking =
                menuDownloadTransaction.is_tracking_only !== null ? true : false
              this.isTracking = menuDownloadTransaction.is_tracking_only
              this.filterTimeAttendance =
                menuDownloadTransaction.is_time_attendance_status_success !==
                null
                  ? true
                  : false
              this.isTimeAttendanceSuccess =
                menuDownloadTransaction.is_time_attendance_status_success
            } else {
              this.transaction_source = this.transactionSources.map(
                (el) => el.transaction_source_uuid
              )
            }
          }
        })
        .catch((error) => {
          this.loading = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
    },
  },
  beforeDestroy() {
    clearTimeout(this.timeout)
  },
}
</script>
